import { createSelector } from 'reselect'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import CreditTotalsOverview, { CreditTotalsOverviewStateProps, CreditTotalsOverviewOwnProps } from 'components/features/pfm/CreditTotalsOverview/CreditTotalsOverview'
import { memberInfoGuard } from 'guards/globalGuards'
import { creditTotalsGuard } from 'guards/creditGuards'
import { creditTotalsSelector } from 'selectors/creditSelectors'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'

const createMapStateToProps = () =>
  createSelector(
    memberInfoSelector,
    creditTotalsSelector,
    (member, totals): CreditTotalsOverviewStateProps => {
      if (!member) {
        throw createForgottenGuardError('CreditTotalsOverviewModuleContainer', 'memberInfoGuard')
      }
      if (!totals) {
        throw createForgottenGuardError('CreditTotalsOverviewModuleContainer', 'creditTotalsGuard')
      }

      return { totals }
    },
  )

const guards: Guards<CreditTotalsOverviewOwnProps> = [
  memberInfoGuard,
  creditTotalsGuard,
]

const CreditTotalsOverviewModuleContainer = connectShadedLoadable<CreditTotalsOverviewStateProps, {}, CreditTotalsOverviewOwnProps>(
  createMapStateToProps, undefined, guards
)(CreditTotalsOverview)
export default CreditTotalsOverviewModuleContainer
